import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Table,  TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import AbEnvironment from '../auth/AbEnvironment'; 
import AppUpdateMutation from '../app/AppUpdateMutation';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
    [theme.breakpoints.up('sm')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingBottom: 0,
            paddingRight: 0,
            width: 948,
            verticalAlign: 'middle',
            borderBottom: 0,
        },
    },
    input: {
      display: 'none',
    },
    [theme.breakpoints.up('xs')]: {
        tblCellLogoCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 10,
            width: 52,
            verticalAlign: 'top',
            borderBottom: 0,
        },
        tblCellDescCol: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            verticalAlign: 'middle',
            borderBottom: 0,
        }
    },
});
/*
* This component displays app information from the app catalog.  It has the logo, app name and maybe SKU,
* and description formatted in a consistent fashion BUT that also allows logo uploading.
*/
class AppDisplayWithMaintenance extends Component {

    handleFileUpload = event => {
        const { callPartnerApi } = this.props.auth;

        let masqueradeAccountId = null;
        if (abEnvironment.isMasquerade()) {
          masqueradeAccountId = localStorage.getItem('m_a_id');
        }   
  
        let appId = this.props.appId
   
        let acctId = abEnvironment.getUserAttribute('a_id');
    
        let theFile = event.target.files[0];
        if (!theFile) {
          return;
        }
        let theFilename = theFile.name;
        let theFiletype = theFile.type;
        let theFilesize = theFile.size;
        // alert('The file size is ' + theFilesize);
        if (theFilesize > 200000) {
          return;
        }
    
        // Call API to save file and return path
        let payload = {
          operation: "getSignedLogoUploadUrl",
          params: {
            filename: theFilename,
            filetype: theFiletype,
            masqAccountId: masqueradeAccountId
          }
        }
        
        callPartnerApi('appbind/generic',
                       'POST',
                       payload)
        .then((resp) => {
          return resp.json();
        })
        .then(theresp => {
          let theurl = theresp.data;
          return fetch(theurl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': theFiletype,
            }),
            body: theFile
          });
        })
        .then(response => {
          // Call an update mutation to set on the account? Probably.
          // The file is being put in logoc/<aid>/fname - so set that on the account
          let theLogoPath = '/logoc/' + acctId + '/' + theFilename;
          
          AppUpdateMutation.commit(appId, null, null, null, null, null, theLogoPath,
                            null, null, null, null, null, null, null)
  
    
        })
        .then(mr => {
          // console.log(mr);
          window.location.reload();
        })
        .catch(error => {
          // Notify that there was an error
          // console.log(error);
        });
    
    }
  

    getTitleLine = () => {
        let theTitleLine;
        if (this.props.appName === this.props.appSku || this.props.appSku == null || this.props.appSku === '') {
            theTitleLine = this.props.appName;
        } else {
            theTitleLine = this.props.appName + " (" + this.props.appSku + ")";
        }

        if (this.props.titleLimit) {
            if (theTitleLine.length > this.props.titleLimit) {
              // Find the space before that.
              let theSubstr = theTitleLine.substring(0, this.props.titleLimit);
              let lastSpaceIdx = theSubstr.lastIndexOf(' ');
              theTitleLine = theTitleLine.substring(0, lastSpaceIdx) + '...';
            }
        }        

        return theTitleLine;
    }

    getDescription = () => {
        let theDescription = this.props.description;
        if (this.props.descriptionLimit) {
            if (theDescription.length > this.props.descriptionLimit) {
              // Find the space before that.
              let theSubstr = theDescription.substring(0, this.props.descriptionLimit);
              let lastSpaceIdx = theSubstr.lastIndexOf(' ');
              theDescription = theDescription.substring(0, lastSpaceIdx) + '...';
            }
        }        

        return theDescription;
    }

    render() {
        const classes = this.props.classes;
        return (
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.tblCellLogoCol}>
                            {this.props.appLogo != null &&
                                <div>
                                    <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="upload-button"
                                    type="file"
                                    onChange={this.handleFileUpload}
                                    />
                                    <Tooltip title="Click to change logo">
                                       <label htmlFor="upload-button">
                                            <Button variant="text" component="span" className={classes.button}>
                                                <img alt="Logo" height="52px" src={this.props.appLogo} />
                                            </Button>
                                      </label>
                                    </Tooltip>
                                </div>
                            }

                            {this.props.appLogo == null &&
                                <div>
                                    <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="upload-button"
                                    type="file"
                                    onChange={this.handleFileUpload}
                                    />
                                    <Tooltip title="Click to upload logo">
                                        <label htmlFor="upload-button">
                                            <Button variant="outlined" component="span" className={classes.button}>
                                                <img alt="Logo" height="48px" src={'/logos/add-logo-225.png'} />
                                            </Button>
                                        </label>
                                    </Tooltip>
                                </div>
                            }
                            
                        </TableCell>
                        <TableCell className={classes.tblCellDescCol}>
                            <Typography variant="h6">{this.getTitleLine()}</Typography>
                            <Typography variant="body2">{this.getDescription()}</Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }


}
  
export default withStyles(styleSheet)(AppDisplayWithMaintenance);